module.exports = __webpack_public_path__ + "assets/zalo.609cdd80.svg";